import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { ConfirmPasswordValidator } from './confirmpassword.validator';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  signUpForm: UntypedFormGroup;
  guestForm: UntypedFormGroup;

  isLoading$: Observable<boolean>;
  returnUrl: string;
  NoWhitespacePatternEnglish = "^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$";
  MobilePattern = "(5)[0-9]{8}";
  PatientId;
  GuestId;
  SecretKey;
  Patient: boolean = true;
  Guest: boolean = false;
  GuestLink: boolean = false;
  ValidateOtp: boolean = true;
  @Input() OtpCode: string;
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  Service:string='';
  constructor(private translationService: TranslationService,
    private authService: AuthService,
    private router: Router, private modal: NgbModal,
    private toast: HotToastService,
    private fb: UntypedFormBuilder,) { this.isLoading$ = this.authService.isLoading$; }

  ngOnInit(): void {
    if (localStorage.getItem("Service")) {
      this.Service = localStorage.getItem("Service");
    }
    this.language = this.translationService.getSelectedLanguage();
    this.InitSignUpForm();
    this.InitGuestForm();
  }
  get SignForm() {
    return this.signUpForm.controls;
  }
  onNoClick(): void {
    this.modal.dismissAll(this.modalContent);
  }
  InitSignUpForm() {
    this.signUpForm = this.fb.group({
      PassportNo: ['', [Validators.required,Validators.minLength(8),Validators.maxLength(15)]],
      Mobile: [null, [Validators.required, Validators.pattern(this.MobilePattern)]],
      Password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.{6,})/)]],
      ConfirmPassword: ['', Validators.required],
      Terms: [],
    }, {
      validator: ConfirmPasswordValidator.MatchPassword,
    });
  }
  InitGuestForm() {
    this.guestForm = this.fb.group({
      IqamaID: ['', [Validators.required, Validators.minLength(8),Validators.maxLength(15)]],
      FName: ['', Validators.required],
      LName: ['', Validators.required],
      Mobile: [null, [Validators.required, Validators.pattern(this.MobilePattern)]],
      Age: ['', [Validators.required, Validators.min(1)]],
      Gender: ['', Validators.required],
      Password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.{6,})/)]],
      ConfirmPassword: ['', Validators.required],
      Terms: [],
    }, {
      validator: ConfirmPasswordValidator.MatchPassword,
    });
  }
  submit() {
    this.signUpForm.markAllAsTouched();
    if (!this.signUpForm.valid) {
      return;
    }
    if (!this.signUpForm.controls.Terms.value) {
      if (this.language == 'ar') {
        this.toast.warning("<b>يجب الموافقة علي البنود والقواعد اولا</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>You must agree with all Terms & Conditions first</b>", { style: { padding: '20px' } });
      }
      return;
    }
    this.hasError = false;
    const Subscr = this.authService.CreateNewAccount(this.SignForm.PassportNo.value, this.SignForm.Mobile.value, this.SignForm.ConfirmPassword.value,this.SecretKey).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {

      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.Login(this.SignForm.PassportNo.value, this.SignForm.ConfirmPassword.value);
        this.onNoClick();
      }
      else if (!res.error.isSuccess && (res.error.responseCode == 404 || res.error.responseCode == 400)) {

        this.ErrorMessage = res.error?.message
        this.hasError = true;
        if (res.error?.message == "بيانات المريض غير موجودة" || res.error?.message == "Patient data Not Exists") {
          this.GuestLink = true;
        }
      }
      else if (!res.error.isSuccess && res.error.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(Subscr);
  }
  submitGuest() {
    this.guestForm.markAllAsTouched();
    if (!this.guestForm.valid) {
      return;
    }
    if (!this.guestForm.controls.Terms.value) {
      if (this.language == 'ar') {
        this.toast.warning("<b>يجب الموافقة علي البنود والقواعد اولا</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>You must agree with all Terms & Conditions first</b>", { style: { padding: '20px' } });
      }
      return;
    }
    this.hasError = false;

    const GuestModel = this.guestForm.value;
    GuestModel.Mobile = GuestModel.Mobile.toString();
    GuestModel.SecretKey = this.SecretKey;
    const Subscr = this.authService.CreateNewAccountForGuest(GuestModel).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {

      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        //this.Login(this.SignForm.PassportNo.value, this.SignForm.ConfirmPassword.value);
        this.router.navigate(['/login']);
        this.onNoClick();
      }
      else if (!res.error.isSuccess && (res.error.responseCode == 404 || res.error.responseCode == 400)) {

        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error.isSuccess && res.error.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(Subscr);
  }
  SendOtpForPatient() {
    this.hasError = false;
    this.Patient = true;
    this.Guest = false;
    //let PassportNo = this.SignForm.PassportNo.value, Mobile = this.SignForm.Mobile.value;
    this.signUpForm.markAllAsTouched();
    if (!this.signUpForm.valid) {
      return;
    }
    if (!this.signUpForm.controls.Terms.value) {
      if (this.language == 'ar') {
        this.toast.warning("<b>يجب الموافقة علي البنود والقواعد اولا</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>You must agree with all Terms & Conditions first</b>", { style: { padding: '20px' } });
      }
      return;
    }
    const Subscr = this.authService.SendOtpForPatient(this.SignForm.PassportNo.value, this.SignForm.Mobile.value).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {

      if (res.data && res.isSuccess) {
        this.modal.open(this.modalContent);
        this.PatientId = res.data.userId;
        this.GuestId = 0;
        this.SecretKey = res.data.otpSecretKey;
        this.OtpCode = res.data.otp;
      }

      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(Subscr);
  }
  SendOtpForGuest() {
    this.hasError = false;
    this.Patient = false;
    this.Guest = true;
    // let PassportNo = this.SignForm.PassportNo.value, Mobile = this.SignForm.Mobile.value;
    this.guestForm.markAllAsTouched();
    if (!this.guestForm.valid) {
      return;
    }
    if (!this.guestForm.controls.Terms.value) {
      if (this.language == 'ar') {
        this.toast.warning("<b>يجب الموافقة علي البنود والقواعد اولا</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>You must agree with all Terms & Conditions first</b>", { style: { padding: '20px' } });
      }
      return;
    }
      const GuestModel = this.guestForm.value;
      // GuestModel.Mobile = GuestModel.Mobile.toString();
      // PassportNo = GuestModel.IqamaID;
      // Mobile = GuestModel.Mobile;
    
    const Subscr = this.authService.SendOtpForGuest(GuestModel.IqamaID, GuestModel.Mobile.toString()).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {

      if (res.data && res.isSuccess) {
        this.modal.open(this.modalContent);
        this.PatientId = 0;
        this.GuestId = res.data.userId;
        this.SecretKey = res.data.otpSecretKey;
        this.OtpCode = res.data.otp;
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(Subscr);
  }
  ValidateOtpCode() {

    if (!this.OtpCode || this.OtpCode == null || this.OtpCode == '') {
      if (this.language == 'ar') {
        this.toast.warning("<b>ادخل الرمز المكون من 6 ارقام اولا ، من فضلك</b>", { style: { padding: '20px' } });

      }
      else {
        this.toast.warning("<b>Enter the 6-digit code, please</b>", { style: { padding: '20px' } });

      }
      return;
    }
    this.authService.showLoader();

    // var UserId = this.PatientId;
    // if (this.PatientId == null || this.PatientId == 0)
    // {
    //   UserId = this.GuestId;
    // }
    var PassportNo = this.SignForm.PassportNo.value;
    if (this.Patient != null && !this.Patient) {
      const GuestModel = this.guestForm.value;
      PassportNo = GuestModel.IqamaID
    }
    const Subscr = this.authService.ValidateOtp(PassportNo, this.OtpCode, this.SecretKey).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {

      if (res.isSuccess && res.responseCode == 200) {
        if (this.Patient != null && this.Patient) {
          this.submit();
        }
        else {
          this.submitGuest();
        }
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "National ID / Iqama or Password is incorrect";
        }
        this.authService.hideLoader();
      }
    });
    this.unsubscribe.push(Subscr);
  }
  Login(PassportNo, Password) {
    const loginSubscr = this.authService.login(PassportNo, Password).subscribe(res => {

      if (res.userId && res.userId != 0 && res.userId != null) {
        if (sessionStorage.getItem("DoctorId")) {
          let DoctorId = JSON.parse(sessionStorage.getItem("DoctorId"));
          let DepartmentId = JSON.parse(sessionStorage.getItem("DepartmentId"));
          this.router.navigate(['/portal/appointments/addappointment/' + DepartmentId + '/' + DoctorId]);
        }
        else if (this.Service == 'BookAppointment')
        {
          this.router.navigate(['/portal/appointments/specialties/']);
        }
        else {
          this.router.navigate(['/portal/dashboard']);
        }
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error.responseCode == 404) {
        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error.isSuccess && res.error.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "National ID / Iqama or Password is incorrect";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(loginSubscr);
  }
  ShowGuestForm() {
    this.Patient = false;
    this.Guest = true;
    this.hasError = false;
    this.guestForm.patchValue({ IqamaID: this.signUpForm.controls.PassportNo.value });
    this.guestForm.patchValue({ Mobile: this.signUpForm.controls.Mobile.value });
    this.guestForm.patchValue({ Password: this.signUpForm.controls.Password.value });
    this.guestForm.patchValue({ ConfirmPassword: this.signUpForm.controls.ConfirmPassword.value });

  }
  ShowPatientForm() {
    this.Patient = true;
    this.Guest = false;
    this.hasError = false;
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  // helpers for View
  isControlValid(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string, FormGroup: UntypedFormGroup) {
    const control = FormGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
